module.exports = __webpack_public_path__ + "img/8a18a82.png";